/**
 * Which standalone stage-tool panel is open, and on which volume.
 *
 * The non-interactive sibling of `tools/segment/store.ts`: `ToolLaunchDialog`
 * opens this once a volume is chosen, for every Tools-menu tool that is not
 * SAM/MedSAM-style interactive. Kept separate from `useToolSession` for the
 * same reason as the segmentation store -- a run that outlives the dialog
 * should not reset if the dialog's own state does.
 */
import { create } from "zustand";

interface StageRunState {
  open: boolean;
  toolId: string | null;
  nodeId: string | null;
  openPanel: (toolId: string, nodeId: string) => void;
  close: () => void;
}

export const useStageRunStore = create<StageRunState>((set) => ({
  open: false,
  toolId: null,
  nodeId: null,
  openPanel: (toolId, nodeId) => set({ open: true, toolId, nodeId }),
  close: () => set({ open: false }),
}));
